/* flow-strict */

/* eslint-disable camelcase */
import _ from 'lodash';
import $ from 'jquery';
import { getRemainQuantity } from '../../utils/buyService';


export const getPieOptions = (props, lang = { days_left: 'days left', hours_left: 'hours left', sold_out: 'sold out' }) => {
  const etime = new Date(_.get(props, 'eventDetail.end_time_utc', Date.now())).getTime();
  const now = new Date(Date.now()).getTime();
  const timespan = etime - now;
  const leftHours = Math.floor(timespan / (3600 * 1000));

  let unit = lang.days_left;

  let  colors = ['#F2F4F8', '#FC3067'];

  let  value = 0;

  let  maxValue = 100;

  if (leftHours > 48) {
    unit = lang.days_left;
    value = Math.floor(leftHours / 24);
    maxValue = value > 90 ? value : 90;
    // The remaining time is less than 3 days, and it is displayed in red
    if (value > 3) {
      colors = ['#F2F4F8', '#00AEEF'];
    }
  } else {
    unit = lang.hours_left;
    value = leftHours;
    maxValue = 48;
  }

  if (getRemainQuantity(props.eventDetail, false, props.ticket) === 0) {
    colors = ['#F2F4F8', '#F2F4F8'];
    maxValue = 100;
    // unit = lang.sold_out;
  }

  const temp_id = `el_${  Math.random(0, 99999)}`;

  const s = unit;
  const $label = $(`#${  temp_id}`);

  if ($label.length > 0) {
    $label.text(s);
  }

  return {
    colors,
    value,
    maxValue,
    unit,
    text: () => {
      // eslint-disable-next-line
      return `<div class="${unit.replace(" ", "_")}"><span>${value}</span><label id="${temp_id}">${unit}</label></div>`;
    }
  };
};
